<nav class="side-menu">
  <div
    class="side-menu__wrapper"
    [ngClass]="{
      close: sideNavToggleBtn
    }"
  >
    <!-- close icon on responsive -->
    <mat-icon (click)="sideNavToggleBtnRes.emit(false)" class="close-icon">
      close
    </mat-icon>
    <!-- logo -->
    <a routerLink="" class="logo">
      <img src="assets/images/logo.svg" alt="logo" />
    </a>
    <ul class="nav-list">
      <!-- menu navigation -->
      @for(item of sideMenu; track $index){ @if(!item.allowedRoles ||
      item.allowedRoles.includes(this.getCurrentRole())){
      <li
        class="nav-item"
        [ngClass]="{
                active:route && route.includes(item.title),
                open: item.hasChildren && openFlag && item.title == routeTitle,
              }"
        routerLinkActive="active"
        (click)="!item.hasChildren ? goTo(item.route) : ''"
        (click)="toggle(true, openFlag, item.title)"
      >
        <a>
          <span class="nav-icon">
            <!-- <img src="{{
                      item.image +
                        (route && route.includes(item.title) ? '-white.svg' : '-white.svg')
                    }}" /> -->
            <mat-icon class="material-symbols-outlined">
              {{ item.icon }}
            </mat-icon>
          </span>
          <span class="nav-title">
            {{ "breadCrumb." + item.title | translate }}
          </span>
        </a>
        <!-- icon for menu navigation if have children route -->
        @if (item.hasChildren) {
        <mat-icon class="expand-icon material-icons-round">
          {{
            openFlag && item.title == routeTitle ? "expand_less" : "expand_more"
          }}
        </mat-icon>
        }
      </li>

      <!-- dropdown for menu navigation if have children route -->
      <ul
        class="dropdown"
        [ngClass]="{
          langEn: _translate.getDefaultLang() == 'en',
          'dropdown-menu':
            sideNavToggleBtn &&
            subMenu &&
            item.hasChildren &&
            item.title == routeTitle,
        }"
        [ngStyle]="{
          display:
            item.hasChildren &&
            item.title == routeTitle &&
            openFlag &&
            !sideNavToggleBtn
              ? 'block'
              : 'none'
        }"
      >
        @if (item.hasChildren) { @for (child of item.children; track $index) {
        @if(!child.allowedRoles ||
        child.allowedRoles.includes(this.getCurrentRole())) {
        <li
          (click)="!child.hasChildren ? goTo(child.route) : ''"
          (click)="
            child.hasChildren
              ? toggleChild(child.title, item.title, $event)
              : ''
          "
          [ngClass]="{
            active: route && activeChildRoute == child.title,
            'nav-item': child.hasChildren
          }"
        >
          <a>
            {{ "breadCrumb." + child.title | translate }}
            @if (child.hasChildren) {
            <mat-icon
              class="expand-icon material-icons-round"
              (click)="toggleChild(child.title, item.title, $event)"
            >
              {{
                isChildOpen(child.title, item.title)
                  ? "expand_less"
                  : "expand_more"
              }}
            </mat-icon>
            }
          </a>
        </li>
        <!-- nested children level (optional) -->
        @if (child.hasChildren) {
        <ul
          class="sub-dropdown"
          [ngStyle]="{
            display:
              isChildOpen(child.title, item.title) &&
              item.title == routeTitle &&
              openFlag &&
              !sideNavToggleBtn
                ? 'block'
                : 'none'
          }"
        >
          @for (subchild of child.children; track $index) {
          @if(!subchild.allowedRoles ||
          subchild.allowedRoles.includes(this.getCurrentRole())) {
          <li
            (click)="goTo(subchild.route)"
            [ngClass]="{ active: route && activeNestedRoute == subchild.title }"
          >
            <a>
              {{ "breadCrumb." + subchild.title | translate }}
            </a>
          </li>
          } }
        </ul>
        } } } }
      </ul>
      } }
      <!-- logout -->
      <li class="nav-item logout" (click)="logout()">
        <a>
          <span class="nav-icon">
            <mat-icon class="material-symbols-outlined"> logout </mat-icon>
          </span>
          <span class="nav-title">
            {{ "breadCrumb." + "logout" | translate }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</nav>
